import React, { useEffect, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { WithAuthUser } from '../components/UserProvider'
import {
  storeInCacheWithExpiry,
  getFromCacheWithExpiry,
} from '../utils/LocalStorageUtil'
import { analyticsService } from '../services/analytics-service/analytics-service'

const PcnView = props => {
  const navigate = useNavigate()
  const location = useLocation()
  const propsForView = getPropsForView(props, location)

  const handleBrowserBackClick = useCallback(() => {
    navigate(-1)
  }, [navigate])

  useEffect(() => {
    window.history.pushState(null, '', location.pathname)
    window.addEventListener('popstate', handleBrowserBackClick)
    // remove event listener on unmount
    return () => {
      window.removeEventListener('popstate', handleBrowserBackClick)
    }
  }, [handleBrowserBackClick, location.pathname])

  // Track pageviews on page change
  useEffect(() => {
    analyticsService.pageNavigationTimerStop(window?.location?.pathname)
    return () => {
      analyticsService.pageView({ path: location.pathname })
      analyticsService.pageNavigationTimerStart(location.pathname)
    }
  }, [location])

  return (
    <div style={{ padding: '8px' }}>
      <WithAuthUser>{props.children(propsForView)}</WithAuthUser>
    </div>
  )
}

const getPropsForView = (props, location) => {
  const state = { location }

  //All of these views need the same props
  if (
    props.view === 'vendor-bids' ||
    props.view === 'vendor-costing-bids' ||
    props.view === 'manage-files' ||
    props.view === 'vendor-alignment' ||
    props.view === 'event' ||
    props.view === 'associateProducts' ||
    props.view === 'addProducts' ||
    props.view === 'reviewBids' ||
    props.view === 'manageBps'
  ) {
    const propsReceived = location?.state?.reactProps ?? null
    let propsToUse: { location } | null = null

    if (propsReceived) {
      propsToUse = state
    } else {
      // when window back navigation is triggered
      const propsFromCache = getFromCacheWithExpiry('viewProps')
      if (propsFromCache && propsFromCache.props) {
        propsToUse = {
          location: {
            ...location,
            state: propsFromCache.props.location.state,
          },
        }
      }
    }

    storeInCacheWithExpiry({
      key: 'viewProps',
      value: { view: props.view, props: propsToUse ?? {} },
      ttl: 1000 * 60 * 60 * 12,
    }) //expires in 12 hours

    return propsToUse
  } else {
    return state
  }
}

export default PcnView
